import React, { useState, useRef } from "react";
import { RecordContextProvider, useTranslate } from 'react-admin';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Typography,
  useMediaQuery,
} from '@material-ui/core';
import {
  AssignmentOutlined as ApproveIcon,
  Check as SignedIcon,
} from '@material-ui/icons'

import { getLineupSignatory, isLineupApproved } from '@hisports/scoresheet/src/selectors';

import { useSignature, SignatureInput } from '../../../common/inputs/SignatureInput';
import { useScoresheet } from '../ScoresheetContext';
import { useIdentity, useSport } from "../../../http";

import { LineupSignatoryField } from "./LineupSignatoryField";


const SignatoryField = ({ participantId }) => {
  const translate = useTranslate();
  return <RecordContextProvider value={{ participantId }}>
    <Typography variant="body2" style={{ fontWeight: 500 }} >{translate('resources.scoresheets.labels.signatory')}</Typography>
    <LineupSignatoryField source="participantId" variant="default" link={false} />
  </RecordContextProvider>
}

const useDialogStyles = makeStyles(() => ({
  paperFullScreen: {
    height: 'unset'
  }
}))
const SignatureDialog = ({ open, teamId, onSave, onClose }) => {
  const translate = useTranslate()
  const sport = useSport();
  const currentUser = useIdentity();
  const ref = useRef(null);
  const { signature, isEmpty, clear, handleChange } = useSignature(ref);
  const fullScreen = useMediaQuery(theme => theme.breakpoints.down('xs'));
  const classes = useDialogStyles();

  const currentUserId = currentUser?.participantId;

  const signatory = useScoresheet(scoresheet => getLineupSignatory(scoresheet, { participantId: currentUserId, sport }))
  const participantId = signatory?.participantId || currentUserId;

  const handleDiscard = () => {
    onClose()
  }

  const handleSave = () => {
    if (isEmpty) return;

    onSave({ participantId, signature });
    onClose();
  }

  return <Dialog open={open} fullWidth fullScreen={fullScreen} maxWidth={fullScreen ? "xs" : "sm"} disableBackdropClick classes={classes}>
    <DialogTitle>{translate('resources.scoresheets.labels.sign_and_approve')}</DialogTitle>
    <DialogContent>
      <DialogContentText>
        {translate('resources.scoresheets.messages.confirm_sign')}
      </DialogContentText>
      <SignatoryField participantId={participantId} />
      <SignatureInput ref={ref} onChange={handleChange} />
    </DialogContent>
    <DialogActions>
      <Button onClick={handleDiscard}>{translate('ra.action.discard')}</Button>
      <Button onClick={clear} disabled={isEmpty}>{translate('ra.action.clear')}</Button>
      <Button color="primary" onClick={handleSave} disabled={isEmpty}>{translate('ra.action.save')}</Button>
    </DialogActions>
  </Dialog>
}

export const SignLineup = ({ teamId, disabled, onSave }) => {
  const translate = useTranslate();
  const [ open, setOpen ] = useState();
  const isApproved = useScoresheet(scoresheet => isLineupApproved(scoresheet, { teamId }))

  if (isApproved) return <Button startIcon={<SignedIcon />} disabled>{translate('resources.scoresheets.labels.signed')}</Button>;
  return <>
    <Button color="primary" variant="contained" startIcon={<ApproveIcon />} disabled={disabled} onClick={() => setOpen(true)}>{translate('ra.action.sign')}</Button>
    {open && <SignatureDialog open={open} teamId={teamId} onSave={onSave} onClose={() => setOpen(false)} />}
  </>
}
